export default __webpack_public_path__ + "static/image2-6fdea45e461362248d09ac62a8142664.jpeg";